/** Normalize list API responses: raw array or { items, next_cursor }. */
export function pageItems(data) {
  if (Array.isArray(data)) return data;
  return data?.items ?? [];
}
